module.exports = __webpack_public_path__ + "src/assets/il.cdc911fc.png";